import { GetCheckoutDetailQueryResponse } from '@queries/checkout/queries/detail';

interface DeliveryCosts {
  oldDeliveryCost: number;
  deliveryCost: number;
}
export function getDeliveryCosts(
  item: GetCheckoutDetailQueryResponse['orderDeliveryOptions'][number],
): DeliveryCosts {
  const usedDeliveryCoupons = item.orders.filter(
    (order) => order.deliveryCoupon,
  ).length;
  const totalCost = item.orders[0].totalCost;
  const productsCost = totalCost - item.deliveryCost;
  const oldDeliveryCost =
    item.orders.length === 2
      ? usedDeliveryCoupons === 2
        ? 3490 + 990
        : usedDeliveryCoupons === 1
        ? productsCost < 35000
          ? 3490 + 990
          : productsCost < 70000
          ? 990
          : null
        : null
      : item.orders.length === 1
      ? usedDeliveryCoupons === 1
        ? 3490
        : null
      : null;
  return {
    oldDeliveryCost,
    deliveryCost: item.deliveryCost,
  };
}
